import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface StatCardProps {
  title: string;
  value: string;
  subLine?: string;
  current: number | null;
  previous: number | null;
  goodWhen: "up" | "down" | "neutral";
  comparisonLabel: string;
}

const StatCard = ({
  title,
  value,
  subLine,
  current,
  previous,
  goodWhen,
  comparisonLabel,
}: StatCardProps) => {
  const hasDelta = current != null && previous != null && previous !== 0;
  const change = hasDelta ? ((current - previous) / previous) * 100 : null;

  let tone = "text-muted-foreground";
  if (change != null && change !== 0 && goodWhen !== "neutral") {
    const improved = goodWhen === "up" ? change > 0 : change < 0;
    tone = improved ? "text-good" : "text-danger";
  }

  return (
    <Card className="gap-2 py-4">
      <CardContent className="space-y-1 px-4">
        <p className="text-sm text-muted-foreground">{title}</p>
        <p className="text-2xl font-bold">{value}</p>
        <div className="flex flex-wrap items-center gap-x-2 text-xs text-muted-foreground">
          <span
            className={cn("font-medium", tone)}
            title={comparisonLabel}
          >
            {change == null
              ? "—"
              : `${change > 0 ? "▲" : change < 0 ? "▼" : ""} ${Math.abs(change).toFixed(1)}%`}
          </span>
          {subLine && <span>· {subLine}</span>}
        </div>
      </CardContent>
    </Card>
  );
};

export default StatCard;
